<template>
  <div>
    <loadingSpan v-if='loading' fix>加载中...</loadingSpan>
    <div class="Info">
      <div class="title">{{this.$route.meta.menuTitle}}</div>
      <div>
        <span>{{`当前门店:${this.$store.state.storeInfo.name ? this.$store.state.storeInfo.name : ''}`}}</span>&nbsp;&nbsp;
      </div>
    </div>
    <div class="content">
      <div class="btns">
        <lk-button type='primary' style="margin-right:10px" @click="signIn">签到</lk-button>
        <lk-button @click="signOut" v-if="isBeiJing">签退</lk-button>
      </div>
      <div class="tableArea">
        <lk-table :columns='columns' :data='tableData' border></lk-table>
      </div>
      <div class="pageTool">
        <lk-page 
          :total="count" 
          show-total 
          show-sizer 
          show-elevator 
          @on-change='handlePage' 
          @on-page-size-change='handleSize'
          :current.sync="page">
        </lk-page>
      </div>
    </div>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import healthInsManage from '../../services/healthInsManage.js';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import LoadingSpan from '../../components/LoadingSpan.vue';

export default {
  name: 'signInSignOut',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    LoadingSpan,
  },
  computed: {
    isBeiJing() {
      return this.storeInfo.id == 7;
    },
  },
  data() {
    return {
      count: 0,
      page: 1,
      size: 10,
      loading: false,
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 116,
        },
        {
          title: '操作人',
          key: 'userName',
          minWidth: 116,
        },
        {
          title: '操作类型',
          key: 'typeName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '状态',
          key: 'statusName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '操作时间',
          key: 'createTime',
          minWidth: 116,
          tooltip: true,
        },
      ],
      tableData: [],
      signTypeArr: ['签到', '签退']
    };
  },
  methods: {
    signIn() {
      healthInsManage.signIn().then((res) => {
        this.loading = true;
        if (res.data.status === 200) {
          this.$Message.success('签到成功');
          this.getRecords();
          this.loading = false;
        } else {
          this.loading = false;
          this.getRecords();
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.loading = false;
        utils.handleError(err);
      })
    },
    signOut() {
      healthInsManage.signOut().then((res) => {
        this.loading = true;
        if (res.data.status === 200) {
          this.$Message.success('签退成功');
          this.getRecords();
          this.loading = false;
        } else {
          this.loading = false;
          this.getRecords();
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.loading = false;
        utils.handleError(err);
      })
    },
    getRecords() { //获取签到记录
      const params = {
        page: this.page,
        size: this.size
      }
      healthInsManage.getSignRecords(params).then((res) => {
        this.loading = true;
        if (res.data.status === 200) {
          this.loading = false;
          if ((res.data.data && res.data.data.list) && (res.data.data.list instanceof Array)) {
            let tempArray = res.data.data.list;
            tempArray.forEach(item => {
              item.createTime = utils.DateToSecond(item.createTime);
            });
            this.tableData = tempArray;
            this.count = res.data.data.count || 0;
          }
        } else {
          this.loading = false;
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.loading = false;
        utils.handleError(err);
      })
    },
    handlePage(page) {
      this.page = page;
      this.getRecords();
    },
    handleSize(size) {
      this.size = size;
      this.getRecords();
    },
  },
  mounted() {
    if (this.roleType !== 1) { //如果是总部角色才现实门店名称那一列, 1总部 2门店 3系统管理员
      this.columns.splice(1,1);
    }
    this.getRecords();
  }
};
</script>
<style lang="less" scoped>
  .Info {
    background-color: #fff;
    height: 60px;
    padding: 10px 0 5px 15px;
    .title {
      font-family: regular;
      font-weight: bold;
      font-size: 12px;
      margin-bottom: 5px;
      color:#515a6e;
    }
  }
  .content {
    background-color: #fff;
    margin: 15px 0 0 10px;
    padding: 15px 15px 20px 15px;
    .btns {
      margin-bottom: 15px;
    }
    .pageTool {
      margin-top: 20px;
      display: flex;
      flex-direction: row-reverse;
    }
  }
</style>
